module.exports = __webpack_public_path__ + "img/maestro.552d866.png";